import React from 'react';
import { createStyles, Grid, makeStyles, TextField } from '@material-ui/core';
import { useTranslation } from '@fluentsms/i18n';

// DataGridFilterMenu styles, nothing more
const useStyles = makeStyles(() =>
  createStyles({
    emptySelect: {
      width: '100%',
      textTransform: 'capitalize',
    },
  }),
);

export const DataGridEmptyFilter = (): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation('componentLibrary');

  return (
    <Grid container>
      {/* Render <select> menu of all available table columns */}
      <Grid item xs={12} sm={6}>
        <TextField id="operator-field" value="" label={t('operator')} className={classes.emptySelect} disabled />
      </Grid>
      {/* Render the filter associated with that column */}
      <Grid item xs={12} sm={6}>
        <TextField id="value-field" value="" label={t('value')} className={classes.emptySelect} disabled />
      </Grid>
    </Grid>
  );
};
export default DataGridEmptyFilter;
